import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
// redux
import { updateUserById } from 'redux/users/operations';
// scss
import 'components/Form/Input.scss';
import './UserEditForm.scss';

const UserEditNameForm = ({ data, closeModal }) => {
  const [nameValue, setNameValue] = useState('');
  const { user_id } = data ?? {};
  const dispatch = useDispatch();

  function onChange(e) {
    setNameValue(e.target.value);
  }
  function onKeyPress(e) {
    const regex = /^[a-zA-Zа-яА-ЯёЁіІїЇєЄґҐ'\s]+$/u;
    const char = String.fromCharCode(e.charCode);
    if (!regex.test(char)) {
      e.preventDefault();
    }
  }
  function onSubmit(e) {
    e.preventDefault();
    if (!user_id) return

    const form = e.currentTarget;
    const data = { name: form?.elements?.name?.value };

    dispatch(updateUserById({ id: user_id, data }));
    closeModal();
  }

  return (
    <>
      <form
        className="user-form"
        id="UserEditNameForm"
        name="userForm"
        onSubmit={onSubmit}
      >
        <label className="auth-form__label label">
          <span>Нове ім’я</span>
          <input
            className="input auth-form__input"
            type="text"
            name="name"
            placeholder="Введіть нове ім’я"
            value={nameValue}
            onChange={onChange}
            onKeyPress={onKeyPress}
            required
            minLength={2}
            autoComplete="off"
          />
        </label>
        <div className="passenger-form__btn-wrap">
          <button type="submit" className="passenger-form__btn passenger-form__btn--submit" > Зберегти </button>
          <button type="button" className="passenger-form__btn passenger-form__btn--cancel" onClick={() => closeModal()} >
            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="none" >
              <path d="M6.51855 1L1.51855 6L6.51855 11" stroke="#B79A5D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            Назад
          </button>
        </div>
      </form>
    </>
  );
};

export default UserEditNameForm;
